import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  BannerListUrlQueryParams,
  BannerListUrlSortField,
  BannerUrlQueryParams
} from "./urls";
import BannerCreateView from "./views/BannerCreate";
import BannerDetails from "./views/BannerDetails";
import BannerListViewComponent from "./views/BannerList";

let lastTableNavigation;

const BannerListView: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    BannerListUrlSortField
  ) as BannerListUrlQueryParams;
  if (window.location.href.includes("vertical")) {
    lastTableNavigation = parseQs(location.search.substr(1));
  }
  return <BannerListViewComponent params={params} />;
};

const BannerDetailsView: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const { ...qs } = parseQs(location.search.substr(1));
  const params: BannerUrlQueryParams = {
    ...qs
  };
  return (
    <BannerDetails
      id={decodeURIComponent(id)}
      params={params}
      lastTableNavigation={lastTableNavigation}
    />
  );
};

export const DiscountSection: React.FC<{}> = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.vouchers)} />
      <Routes>
        <Route path={""} element={<BannerListView />} />
        <Route path={"add"} element={<BannerCreateView />} />
        <Route path={":id"} element={<BannerDetailsView />} />
      </Routes>
    </>
  );
};
export default DiscountSection;
